<template>
  <div class="col-xs-12 top-document" data-toggle="collapse" :data-target="'#collapse-'+ author.authorID" aria-expanded="false" :aria-controls="'collapse-'+ author.authorID">
    <table class="col-xs-12" style="">
      <tr :class="{selected: author.selected}">
        <template v-if="context.name === 'expertResult'">
          <td class="col-md-5 col-xs-5" style="vertical-align: middle">
            <table class="table" style="width: 100%;">
              <td class="col-xs-6 col-md-6" v-if="author.affiliation && author.affiliation.organisationID" style="">{{author.lastName}}</td>
              <td class="col-xs-6 col-md-6 text-center" style="vertical-align: middle">
                <flag v-if="author.affiliation && author.affiliation.organisationID" :squared="false" :iso="getIso(author.affiliation)" style="height: 100%"/>
              </td>
            </table>
          </td>

          <template v-if="topDocument">
            <td class="col-md-3 col-xs-3 " style="">{{sourceType}}</td>
          </template>
          <template v-else>
            <td class="col-md-3 col-xs-3 " style=""></td>
          </template>

          <td class="col-md-2 col-xs-2 text-center" :class="{hidden: context.name !== 'expertResult'}" style="vertical-align: center">
            <select :id="'score-'+ author.authorID" v-if="topDocument">
              <option value="3">3</option>
              <option value="2">2</option>
              <option value="1">1</option>
            </select>
          </td>
          <td class="col-md-2 col-sm-2 text-center" style="vertical-align: center">
            <dropdown-company v-model="author" :context="context"></dropdown-company>
          </td>
        </template>
        <template v-else>
          <td class="visible-md visible-lg visible-xl col-md-2 col-lg-2 col-xl-1 text-center">
            <div class="checkbox checkbox-info">
              <input type="checkbox" @click="checked" v-model="author.checked">
              <label></label>
            </div>
          </td>
          <td class="col-xs-6 col-md-5 col-lg-5 col-xl-6" style="vertical-align: middle">
            <table class="table" style="width: 100%;">
              <td class="col-xs-4 col-md-5 text-center" style="vertical-align: middle">
                <flag v-if="author.affiliation && author.affiliation.organisationID" :squared="false" :iso="getIso(author.affiliation)" style="height: 100%"/>
              </td>
              <td class="col-md-8 col-xs-7 "  v-if="author.affiliation && author.affiliation.organisationID" style="">{{author.lastName}}</td>

            </table>
          </td>
          <template v-if="sourceType">
            <td class="col-xs-4 col-md-3 col-lg-3 col-xl-4 " style="">{{sourceType}}</td>
          </template>
          <template v-else>
            <td class="col-xs-4 col-md-3 col-lg-3 col-xl-4" style=""></td>
          </template>
          <td class="col-xs-2 col-md-2 col-lg-2 col-xl-1 text-center" style="vertical-align: center">
            <dropdown-company v-model="author" :context="context"></dropdown-company>
          </td>
        </template>
      </tr>
    </table>

    <div style="bottom: -9px;position: absolute;width: 100%">
      <span style="margin-left: 49%;background-color: white;">
        <button style="border-radius: 50px;font-size: 0.6rem;" class="btn btn-info btn-xs">
        <i class="fa fa-chevron-down"></i>
        </button>
      </span>
    </div>
  </div>
</template>

<style scoped>
  .selected {
    border-left: 5px solid #3498db;
  }

  .dropdown-menu {
    min-width: 50px;
  }
  div > .dropdown > i {
    cursor: pointer;
  }

  .dropdown-expert-action > ul > li i{
    font-weight: bold;
    margin-right: 5px;
  }

  .dropdown-expert-action ul > li a{
    font-size: 12px;
  }

  .dropdown-expert-action ul > li{
    margin-bottom: 5px;
    font-size: 12px;
  }

  .top-document {
    cursor: pointer;
    /*max-height: 80px;*/
    padding: 15px 0;
    border-bottom: 1px solid #eaeaea;
  }
  .top-document:hover {
    background: #f5f5f5;
  }

</style>
<style>
  .br-theme-bars-horizontal .br-widget a {
    height: 10px !important;
    background-color: rgba(0, 123, 225, 0.3) !important;

  }

  .br-theme-bars-horizontal .br-widget a.br-active, .br-theme-bars-horizontal .br-widget a.br-selected {
    background-color: #007bff !important;
  }
</style>
<script>
import 'jquery-bar-rating/dist/jquery.barrating.min'
import 'jquery-bar-rating/dist/themes/bars-horizontal.css'
import IsoCountries from 'i18n-iso-countries'
import EnCountries from '../../iconFlag/en'
import DropdownCompany from './DropdownCompany'

IsoCountries.registerLocale(EnCountries)

export default {
  components: {DropdownCompany},
  name: 'CompanyTop',
  props: ['value', 'context'],
  data () {
    return {
      topDocument: null,
      author: null
    }
  },
  watch: {
    value: function (val) {
      this.author = val
    },
    author: function (val, oldVal) {
      if (oldVal !== null) {
        this.$emit('input', val)
      }
    }
  },
  computed: {
    sourceType: function () {
      let patent = false
      let wiki = false
      let aichat = false

      this.author.docs.forEach((doc) => {
        if (doc.publication === 'European Patent Office') {
          patent = true
        }
        if (doc.sourceID && doc.sourceID === 28) {
          wiki = true
        } else if (doc.sourceID && doc.sourceID === 29) {
          aichat = true
        }
      })

      return patent === true ? 'Patent Applicant' : wiki === true ? 'Wikipedia Database' : aichat === true ? 'AI provider - Beta' : 'Companies Database'
    }
  },
  methods: {
    initScore: (author) => {
      let score = 0
      if (author.score <= 0.1) {
        score = 1
      } else if (author.score < 0.5) {
        score = 2
      } else {
        score = 3
      }
      let scoreElement = $('#score-' + author.authorID)

      scoreElement.barrating({
        theme: 'bars-horizontal',
        readonly: true,
        showSelectedRating: false,
        hoverState: false,
        reverse: true,
        initialRating: score
      })
    },
    getIso: (affiliation) => {
      if (typeof affiliation !== 'undefined') {
        let iso = IsoCountries.getAlpha2Code(affiliation.country, 'en')
        if (typeof iso === 'undefined') {
          iso = IsoCountries.toAlpha2(affiliation.code)
        }
        return iso
      }
    },
    checked: function (event) {
      this.$emit('companyChecked', this.author)

      if (typeof event.stopPropagation !== 'undefined') {
        event.stopPropagation()
      }
    }
  },
  beforeMount () {
    this.author = this.value

    this.author.docs.sort(function (doc1, doc2) {
      return new Date(doc2.pubDate) - new Date(doc1.pubDate)
    })

    this.topDocument = this.author.docs[0]
  },
  updated () {
    this.topDocument = this.author.docs[0]
    this.initScore(this.author)
  },
  mounted () {
    this.initScore(this.author)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/CompanyTop.vue